<template>
    <div class="flex items-center">
        <input class="form-checkbox focus:ring-indigo-400 border-gray-300 rounded h-4 w-4 transition" :class="activeColor" :id="name"
               :name="name" type="checkbox" @click="toggleState">
        <label class="ml-2 block text-sm leading-5 text-gray-900 dark:text-gray-300" :for="name">
            {{ label }}
        </label>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',

    props: {
        name: {
            type: String,
            required: true,
        },
        form: {
            type: Object,
            default: () => {},
        },
        label: {
            type: String,
        },
        activeColor: {
            type: String,
            default: 'text-indigo-600',
        },
    },

    data() {
        return {
            active: false,
        };
    },

    watch: {
        active: function(value) {
            this.$emit('input', value);
        },
    },

    methods: {
        toggleState() {
            this.active = !this.active;
        },
    },
};
</script>
